import React from 'react';
import { CustomInput } from '../reusable-components/customInput';
import * as CONSTANTS from '../../utils/constant';
import {
  ContactFieldDisabled,
  FormInput,
} from '../../types/contactInfo-library.types';

export function FormSection({
  formInputState,
  handleChangeInput,
  formDisableField,
  formInputErrorState,
  onBlurField,
  onKeyPressField,
}: {
  formInputState: FormInput;
  formInputErrorState: FormInput;
  formDisableField: ContactFieldDisabled;
  handleChangeInput: (x: {}) => void;
  onBlurField: (x: {}) => void;
  onKeyPressField: (x: {}) => void;
}) {
  const inputFielsObj = [
    {
      id: 'address1',
      type: 'input',
      label: CONSTANTS.ADDRESS,
      disable: formDisableField.address1Disable,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.address1,
      val: formInputState.address1,
    },
    {
      id: 'address2',
      type: 'input',
      disable: formDisableField.address2Disable,
      label: CONSTANTS.ADDRESS2,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.address2,
      val: formInputState.address2,
    },
    {
      id: 'city',
      type: 'input',
      disable: formDisableField.cityDisable,
      label: CONSTANTS.CITY,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.city,
      val: formInputState.city,
    },
    {
      id: 'state',
      type: 'select',
      disable: formDisableField.stateDisable,
      label: CONSTANTS.STATE,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.state,
      val: formInputState.state,
    },
    {
      id: 'zip',
      type: 'number',
      disable: formDisableField.zipDisable,
      label: CONSTANTS.ZIP_CODE,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.zip,
      val: formInputState.zip,
    },
    {
      id: 'homePhone',
      type: 'number',
      disable: formDisableField.homePhoneDisable,
      label: CONSTANTS.HOME_PHONE_NUMBER,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.homePhone,
      val: formInputState.homePhone,
    },
    {
      id: 'workPhone',
      type: 'number',
      disable: formDisableField.workPhoneDisable,
      label: CONSTANTS.WORK_PHONE_NUMBER,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.workPhone,
      val: formInputState.workPhone,
    },
    {
      id: 'mobilePhone',
      type: 'number',
      disable: formDisableField.mobilePhoneDisable,
      label: CONSTANTS.MOBILE_PHONE_NUMBER,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.mobilePhone,
      val: formInputState.mobilePhone,
    },
    {
      id: 'email',
      type: 'input',
      disable: formDisableField.emailDisable,
      label: CONSTANTS.PERSONAL_EMAIL,
      onChange: handleChangeInput,
      onBlur: onBlurField,
      onKeyPress: onKeyPressField,
      err: formInputErrorState.email,
      val: formInputState.email,
    },
  ];

  return (
    <>
      {inputFielsObj.map((form) => (
        <CustomInput
          key={form.label + form.type}
          id={form.id}
          disable={form.disable}
          type={form.type}
          label={form.label}
          onChange={form.onChange}
          onBlur={form.onBlur}
          onKeyPress={form.onKeyPress}
          err={form.err ? form.err : ''}
          val={form.val ? form.val : ''}
        />
      ))}
    </>
  );
}
